import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";

const SectionTitle = ({ children }) => (
    <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
        {children}
    </h2>
);

export default function ScheduleDates({ data, title }) {
    const dates = data?.schedule?.dates ?? {};

    if (dates?.type === "LIST") {
        const dateList = dates?.dateList ?? [];

        return (
            <div className="space-y-4 px-5">
                <SectionTitle>{title}</SectionTitle>

                <section className="flex flex-wrap gap-2">
                    {dateList.map((date, index) => (
                        <span
                            key={`${date}-${index}`}
                            className="rounded-[5px] border border-[#e0e0e0] bg-[#f7f7f7] px-2 py-1 text-[14px] text-[#161616]"
                        >
                            {date}
                        </span>
                    ))}
                </section>
            </div>
        )
    }

    const recurrence = dates?.recurrence ?? {};

    const items = [
        {
            label: "Data inicial",
            value: projectUtils.formatDate(recurrence?.start, "DD/MM/YYYY") ?? "",
        },
        {
            label: "Data final",
            value: projectUtils.formatDate(recurrence?.end, "DD/MM/YYYY") ?? "",
        },
        {
            label: "Horário",
            value: recurrence?.hour ?? "",
        },
        {
            label: "Dias da semana",
            value: recurrence?.weekdays ?? "",
        },
    ];

    return <InfoGrid title={title} items={items} columns={2} />;
}
